<template>
  <section class="favourites-onboarding" :class="{ desktop: isDesktop }">
    <img loading="lazy" src="~/assets/images/arrow.svg" class="arrow" />
    <div class="callout">
      <translate tag="p">
        Visit the Favourites section to share and edit your lists.
      </translate>
      <div class="action-buttons">
        <base-checkbox v-model="showAgain">
          <translate>Don't show this again</translate>
        </base-checkbox>
        <base-button css-class="sml primary" @click="closeAlert">
          <translate>Got it!</translate>
        </base-button>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, onUnmounted, ref } from 'vue'

const onboardingStore = useOnboardingStore()
const isActive = ref(true)
const showAgain = ref(true)
const isMounted = ref(true)

const { $puScrollTo, $isDesktop } = useNuxtApp()

const closeAlert = () => {
  if (!isMounted.value) return
  if (isActive) {
    isActive.value = false
  }
  if (onboardingStore && onboardingStore.setFavouritesOnboardingState) {
    onboardingStore.setFavouritesOnboardingState({
      shown: showAgain.value,
      closed: true,
    })
  }
}

onMounted(() => {
  if (!isMounted.value) return
  $puScrollTo('#page-wrapper', {
    duration: 300,
  })
})

onBeforeUnmount(() => {
  if (closeAlert) {
    closeAlert()
  }
})

onUnmounted(() => {
  isMounted.value = false
})

const isDesktop = computed(() => {
  return $isDesktop
})

// Head functionality
useHead({
  bodyAttrs: {
    'data-highlight-favourites-navigation': isActive.value ? 'true' : 'false',
  },
})
</script>

<style>
[data-highlight-favourites-navigation='true'] {
  overflow: hidden;
}

[data-highlight-favourites-navigation='true'] .app-header {
  z-index: 11;
}

[data-highlight-favourites-navigation='true'] a.favourites-link {
  z-index: 9;
  position: relative;
  pointer-events: none;
}

[data-highlight-favourites-navigation='true'] a.favourites-link:after {
  height: 2.6em;
  left: 0.7em;
  top: 0;
  width: 2.6em;
  border-radius: 50%;
  box-shadow: 0 0 0 3000px rgba(0, 0, 0, 0.65);
  content: '';
  position: absolute;
  z-index: -1;
  pointer-events: none;
}

[data-highlight-favourites-navigation='true'] .search-results-column,
[data-desktop-search='true'][data-highlight-favourites-navigation='true']
  .breadcrumbs {
  z-index: -1 !important;
}

/* desktop & tablet */
[data-highlight-favourites-navigation='true']
  .user-favourites-link
  a.favourites-link {
  color: var(--colour-dark-blue);
  background-color: white;
}

[data-highlight-favourites-navigation='true']
  .user-favourites-link
  a.favourites-link:after {
  height: 100%;
  left: 0;
  top: 0;
  width: 100%;
  border-radius: 2em;
  border: 3px solid var(--colour-orange);
}
</style>
<style scoped>
.favourites-onboarding {
  position: absolute;
  z-index: 14;
  top: 0;
  margin: 1em;
  width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.callout {
  overflow: hidden;
  background: white;
  padding: 1.4em;
  border-radius: 1em;
}

p {
  color: var(--colour-text-default);
  font-size: var(--body);
}

.action-buttons {
  padding: 2em 0 0;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.action-buttons :deep(button) {
  flex-shrink: 0;
}

.favourites-onboarding :deep(label) {
  font-size: var(--small);
  margin: 0;
}

.arrow {
  width: 4em;
  padding: 0.5em;
}

/* desktop & tablet */
.desktop.favourites-onboarding {
  position: fixed;
  top: 10em;
  left: 50%;
  transform: translate(-50%, -50%);
}

.desktop.favourites-onboarding p {
  font-size: inherit;
}

.desktop.favourites-onboarding .arrow {
  margin: auto auto auto 21vw;
}
</style>
